// --- Snowfall Script ---
document.addEventListener("DOMContentLoaded", () => {
  const snowContainer = document.createElement("div");
  snowContainer.classList.add("snow-container");
  document.body.appendChild(snowContainer);

  const totalFlakes = 80;

  for (let i = 0; i < totalFlakes; i++) {
    let snowflake = document.createElement("div");

    // 5% chance to use a Gastley image flake
    const isGastley = Math.random() < 0.05;

    if (isGastley) {
      snowflake.classList.add("snowflake", "gastley-flake");

      // Randomly assign red or green
      const randomPick = Math.random() < 0.5 ? "gastley-red" : "gastley-green";
      snowflake.classList.add(randomPick);

      // --- RANDOM SIZE for Gastley flakes ---
     // --- RANDOM SIZE for Gastley flakes ---
      let size;
      if (window.innerWidth < 768) {
        size = Math.floor(Math.random() * 10) + 22; // mobile: 22–32px
      } else {
        size = Math.floor(Math.random() * 10) + 30; // desktop: 30–40px
      }
      snowflake.style.width = size + "px";
      snowflake.style.height = size + "px";


    } else {
      snowflake.classList.add("snowflake");

      // --- RANDOM SIZE for normal snowflakes ---
      const size = Math.random() * 3 + 2; // 2–5px
      snowflake.style.width = size + "px";
      snowflake.style.height = size + "px";
    }

    // --- EVEN DISTRIBUTION ACROSS SCREEN ---
    snowflake.style.left = (i / totalFlakes) * 100 + "vw";

    // --- RANDOM DRIFT WITHIN SLICE ---
    snowflake.style.left = `calc(${snowflake.style.left} + ${Math.random() * 20 - 10}px)`;

    // Timing
    snowflake.style.animationDelay = Math.random() * 3 + "s";
    snowflake.style.animationDuration = 5 + Math.random() * 6 + "s";

    snowContainer.appendChild(snowflake);

    // --- FADE IN ---
    setTimeout(() => {
      snowflake.classList.add("fade-in");
    }, 50);
  }
});

